import { Card, HeaderMenu } from "components";
import { Table } from "../SetStockByLocation/components";
import { useEffect, useState } from "react";
import { default_pagination_value } from "utils";
import { FormProvider, useForm } from "react-hook-form";
// import { stockSchema } from "../SetStockByLocation/schemas/setStockByLocationSchemas";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateAllGlobal } from "./components/CreateAll";
import { useStoreSelectedRows } from "../SetStockByLocation/store";
import { useListStockGlobal } from "./hooks/useListStockGlobal";
import { FilterTypeSetStockGlobal } from "./types/SetStockGlobalTypes";
import { Filter } from "./components/Filter";
import { FormSetStockGlobalType, stockSchema } from "./schemas/setStockGlobalSchema";

export default function SetStockGlobal() {

    // state
    const [filter, setFilter] = useState<FilterTypeSetStockGlobal>({
        ...default_pagination_value,
        zero_soh: true,
        zero_min: true,
        zero_max: true
    })

    // store
    const { clear } = useStoreSelectedRows()

    // hooks
    const data = useListStockGlobal(filter)

    // form
    const methods = useForm<FormSetStockGlobalType>({
        resolver: yupResolver(stockSchema),
        defaultValues: {
            items: [],
        }
    })

    useEffect(() => {
       clear()
    }, [filter, clear])

    useEffect(() => {
        if (!data?.data?.items?.length) return

        methods.reset({
            items: data.data.items.map(r => ({
                product_id: r.product_id!,
                location_id: r.location_id ?? null,
                mr_product_category_id: Number(r.mr_product_category_id) ?? null,
                mr_unit_id: r.unit_convention_id ?? null,
                min_qty: Number(r.min_qty) ?? 0,
                max_qty: Number(r.max_qty) ?? 0,
            })),
        })

        clear()

    }, [data?.data?.items, methods, clear])

    return (
        <section className="container my-5">
            <HeaderMenu title="SET STOCK GLOBAL" className="sticky top-[32px] z-[1]" />
            <section className="my-2">
                <section className="mt-2 sticky top-[120px] z-[1]">
                    <Card>
                        <Card.Body>
                            <Filter
                                filter={filter}
                                setFilter={setFilter}
                            />
                        </Card.Body>
                    </Card>
                </section>
            </section>

            <section className="mt-2">
                <Card>
                    <Card.Body>
                        <FormProvider {...methods}>
                            <div>
                                <Table
                                    filter={filter}
                                    setFilter={setFilter}
                                    data={data}
                                    isGlobal={true}
                                />

                                <div className="mt-4 flex justify-end">
                                    <CreateAllGlobal 
                                        refecth={data.refetch}
                                    />
                                </div>
                            </div>
                        </FormProvider>

                    </Card.Body>
                </Card>
            </section>
        </section>
    )
}